// Throwaway mock feed — used only when main.tsx detects ?demo=history so the
// HistoryScreen container can be eyeballed before real wire-up (hh-46n) lands.
// Not exported from the chat barrel. Delete once HistoryScreen mounts a
// DB-backed feed in AppShell.

import type { Message } from './Message';

export const MOCK_FEED: readonly Message[] = [
  {
    id: 'm1',
    kind: 'user',
    text: 'Положил палатку и спальник в кладовку на даче.',
    time: '14:02',
  },
  {
    id: 'm2',
    kind: 'ai_summary',
    text: 'Готово — записал.',
    actions: [
      { kind: 'create', name: 'палатка', to: 'Кладовка · Дача' },
      { kind: 'create', name: 'спальник', to: 'Кладовка · Дача' },
    ],
    undoable: true,
    agentActionId: 'act-101',
    time: '14:02',
  },
  {
    id: 'm3',
    kind: 'user',
    text: 'А где у меня лежит зимняя резина?',
    time: '14:05',
  },
  {
    id: 'm4',
    kind: 'ai_text',
    text: 'Зимняя резина — в гараже, на стеллаже у дальней стены.',
    time: '14:05',
  },
  {
    id: 'm5',
    kind: 'user',
    text: 'Переложи удочки, палатку и фонарик в кладовку, старую палатку выкинь.',
    time: '15:12',
  },
  {
    id: 'm6',
    kind: 'ai_summary',
    text: 'Готово — обновил три записи.',
    actions: [
      { kind: 'move', name: 'удочки', from: 'Балкон', to: 'Кладовка · Дача' },
      { kind: 'move', name: 'фонарик', from: 'Гараж', to: 'Кладовка · Дача' },
      { kind: 'delete', name: 'старая палатка' },
    ],
    undoable: true,
    agentActionId: 'act-102',
    time: '15:12',
  },
  {
    id: 'm7',
    kind: 'user',
    text: 'Положи ключи в кладовку.',
    time: '15:20',
  },
  {
    id: 'm8',
    kind: 'ai_clarify',
    text: 'Две кладовки — в какую положить ключи?',
    options: [
      { id: 'opt-dacha', label: 'Кладовка · Дача', hint: 'рыболовное, инвентарь' },
      { id: 'opt-flat', label: 'Кладовка · Квартира', hint: 'инструменты, бытовое' },
    ],
    time: '15:20',
  },
  {
    id: 'm9',
    kind: 'ai_clarify',
    text: 'Где именно лежит запасной ключ? Две связки.',
    options: [
      { id: 'k-car', label: 'Ключи · Машина' },
      { id: 'k-home', label: 'Ключи · Дом' },
    ],
    resolvedOptionId: 'k-home',
    time: '15:22',
  },
  {
    id: 'm10',
    kind: 'ai_summary',
    text: 'Запись недельной давности — окно отмены закрыто.',
    actions: [{ kind: 'create', name: 'фонарик', to: 'Кладовка · Дача' }],
    undoable: false,
    time: 'вчера',
  },
];
